/* eslint-disable */
export default {
  init() {
    // scripts here run on the DOM load event
  $(document).ready(function() {
   $('.contact-us').click(function(e) {
	e.preventDefault(); 
	let num = $('.item-number dd').text(); 
  let title = $('.page-header h1').text(); 
  let link = window.location.href; 
	localStorage.setItem('item_data', JSON.stringify({ num, title, link }) ); 
    window.location.href = window.location.protocol + '//' + window.location.hostname + '/contact'; 
   }); 
  }); 
  },
  finalize() {
    // scripts here fire after init() runs
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/product.js